import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  InputGroup,
  FormControl,
  ButtonGroup,
  Dropdown,
  Button,
  OverlayTrigger,
  Tooltip,
  Form,
} from "react-bootstrap";
import api from "../../../utils/ApiMethod";
import { downloadExcel } from "react-export-table-to-excel";
import { ADMIN_LOGIN_BASE_URL } from "../../../apiservices/apiService";

const SessionSelector = (props: any) => {
  // console.log(props, "props");
  const [session, setSession] = useState<any>([]);
  const [selectedSession, setSelectedSession] = useState<number | "">("");
  const [isResponse, setIsResponse] = useState("");
  const [studentDataBySession, setStudentDataBySession] = useState<any>();
  //console.log(studentDataBySession, "studentDataBySession");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.fetchData(`/api/all/session`);
        if (response.status !== 200) {
          const errorMsg = await response.json();
          setIsResponse(errorMsg?.message || "Unknown error occurred.");
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        setSession(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsResponse("Error fetching courses. Please try again later.");
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const course_name = "01";
    const fetchData = async () => {
      try {
        if (selectedSession !== 0) {
          const response = await api.fetchData(
            `/api/all/ug/student/${course_name}/${selectedSession}`
          );
          if (response.status !== 200) {
            const errorMsg = await response.json();
            setIsResponse(errorMsg?.message || "Unknown error occurred.");
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          if (response.status === 440) {
            alert("Session Expired");
            window.location.href = `${ADMIN_LOGIN_BASE_URL}/auth/login`; // Use the full URL, including the protocol (http or https)
          }
          setStudentDataBySession(response.data.data);
          props.setSessionWiseDataMBBS(response.data.data);
        }
        else {
          const response = await api.fetchData(
            `/api/UG/students/${course_name}`
          );
          if (response.status !== 200) {
            const errorMsg = await response.json();
            setIsResponse(errorMsg?.message || "Unknown error occurred.");
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          if (response.status === 440) {
            alert("Session Expired");
            window.location.href = `${ADMIN_LOGIN_BASE_URL}/auth/login`; // Use the full URL, including the protocol (http or https)
          }
          setStudentDataBySession(response.data.data);
          props.setSessionWiseDataMBBS(response.data.data);

        }
      } catch (error) {
        console.log(error, "error in fetching data from api on session based");
      }
    };
    fetchData();
  }, [selectedSession]);

  const handleSessionChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedSession(parseInt(event.target.value));
    props.setGetSessionFromSelector(parseInt(event.target.value));
  };

  const header = [
    "sl.no",
    "id",
    "course_name",
    "form_no",
    "enrollment_no",
    "session",
    "admission_date",
    "roll_number",
    "rank",
    "name",
    "dob",
    "category",
    "category_selected",
    "gender",
    "nationality",
    "religion",
    "student_mobile",
    "email",
    "aiims_email",
    "identification_mark",
    "std_bloodgrp",
    "father_name",
    "mother_name",
    "corr_stateName",
    "corr_districtName",
    "corr_town",
    "corr_police_station",
    "corr_post_office",
    "corr_street_address",
    "corr_pin",
    "corr_landline",
    "corr_mobile",
    "corr_email",
    "perm_stateName",
    "perm_districtName",
    "perm_town",
    "perm_police_station",
    "perm_post_office",
    "perm_street_address",
    "perm_pin",
    "perm_landline",
    "perm_mobile",
    "perm_email",
    "gardi_fname",
    "gard_lname",
    "gard_mobile",
    "guardian_email",
    "relation",
    "gardian_address",
  ];

  const bodyRecord = studentDataBySession?.map((record: any, index: any) => [
    index + 1,
    record._id,
    record.course_name,
    record.form_no,
    record.enrollment_no,
    record.session,
    record.admission_date,
    record.roll_number,
    record.rank,
    record?.first_name + " " + record?.middle_name + " " + record?.last_name,
    record.dob,
    record.category,
    record.category_selected,
    record.gender,
    record.nationality,
    record.religion,
    record.student_mobile,
    record.email,
    record.aiims_email,
    record.identification_mark,
    record.std_bloodgrp,
    record.father_name,
    record.mother_name,
    record.corr_stateName,
    record.corr_districtName,
    record.corr_town,
    record.corr_police_station,
    record.corr_post_office,
    record.corr_street_address,
    record.corr_pin,
    record.corr_landline,
    record.corr_mobile,
    record.corr_email,
    record.perm_stateName,
    record.perm_districtName,
    record.perm_town,
    record.perm_police_station,
    record.perm_post_office,
    record.perm_street_address,
    record.perm_pin,

    record.perm_landline,
    record.perm_mobile,
    record.perm_email,
    record.gardi_fname,
    record.gard_lname,
    record.gard_mobile,
    record.guardian_email,
    record.relation,
    record.gardian_address,
  ]);

  function handleDownloadExcel() {
    if (selectedSession) {
      downloadExcel({
        fileName: `Students Data Sheet of session ${selectedSession}`,
        sheet: `Student Data of session ${selectedSession}`,
        tablePayload: {
          header,
          body: bodyRecord,
        },
      });
    } else {
      alert("please select Session");
    }
  }

  return (
    <>
      <Row>
        <Col xs={12}>
          <div className="d-block">
            <div className="float-lg-end">
              <div className="d-lg-flex align-items-center mb-2 mt-0">
                <ButtonGroup>
                  <Dropdown>
                    <select
                      className="form-select"
                      value={selectedSession}
                      onChange={handleSessionChange}
                      aria-label="Session"
                    >
                      <option value={0}>Session</option>
                      {session?.map((session: any) => (
                        <option
                          key={session.sessionYear}
                          value={session.sessionYear}
                        >
                          {session.sessionYear}
                        </option>
                      ))}
                    </select>
                  </Dropdown>

                  <Dropdown>
                    <Dropdown.Toggle variant="light">
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="viewoptions">View Options</Tooltip>
                        }
                      >
                        <Button variant="success" className="">
                          <span className="text-dark">
                            <i className="bi bi-file-earmark-excel"></i>
                          </span>
                        </Button>
                      </OverlayTrigger>
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      {/* <Dropdown.Item
                        href="#"
                        className="text-center border-bottom"
                      >
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="newwindow">New Window</Tooltip>}
                        >
                          <i className="bi bi-window me-2 fs-15"></i>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="newfolder">New Folder</Tooltip>}
                        >
                          <i className="bi bi-folder-plus fs-15"></i>
                        </OverlayTrigger>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        Edit
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="cut">Cut</Tooltip>}
                        >
                          <i className="bi bi-scissors mx-2 fs-15"></i>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="copy">Copy</Tooltip>}
                        >
                          <i className="bi bi-clipboard-check me-2 fs-15"></i>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="paste">Paste</Tooltip>}
                        >
                          <i className="bi bi-clipboard-data fs-15"></i>
                        </OverlayTrigger>
                      </Dropdown.Item>
                      <Dropdown.Item>Select All</Dropdown.Item>
                      <Dropdown.Item className="d-flex">
                        <Form.Check>
                          <Form.Check.Input
                            type="checkbox"
                            className="me-2"
                            id="hiddenFiles"
                          />
                        </Form.Check>
                        Show Hidden Files
                      </Dropdown.Item>
                      <Dropdown.Item className="d-flex">
                        <Form.Check>
                          <Form.Check.Input
                            type="checkbox"
                            className="me-2"
                            id="hiddenFiles"
                          />
                        </Form.Check>
                        Show Sidebar
                      </Dropdown.Item>
                      <Dropdown.Item>Help</Dropdown.Item> */}
                      <Dropdown.Item onClick={handleDownloadExcel}>
                        Excel Export
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </ButtonGroup>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default React.memo(SessionSelector);
// export default SessionSelector;
